/**
 * Service Worker 등록.
 *
 * **SDK 가 아니라 앱이 한다** (`WebPushAdapter` 주석 — 스크립트 경로·스코프·갱신 시점은
 * 앱의 사정이고, SDK 가 정해 버리면 앱이 자기 SW 를 둘로 나누게 된다).
 *
 * ── 설정을 쿼리로 싣는다 ──────────────────────────────────────
 *
 * `public/sw.js` 는 앱이 닫힌 채 깨어난다. 그때 `localStorage` 도 페이지도 볼 수 없어
 * 서버 주소·API Key·deviceId 를 알 방법이 없는데, **브라우저는 등록된 스크립트 URL 을
 * 그대로 보관했다가 그 URL 로 SW 를 깨운다.** 그래서 쿼리에 실어 두면 몇 달 뒤에도 읽힌다.
 *
 * 스코프는 `/` 다. 스크립트가 `/sw.js` 에 있으므로 기본값이 이미 `/` 이지만 명시한다 —
 * Deep Link 가 `/tv2m/product` 로 들어오고 그 창이 SW 의 제어 밖이면
 * `notificationclick` 의 `clients.matchAll()` 이 그것을 찾지 못한다.
 *
 * 같은 URL 로 두 번 불러도 브라우저가 기존 등록을 돌려준다. 그래서 호출부가 횟수를
 * 세지 않아도 된다 — 다만 **`deviceId` 가 바뀌면 URL 이 바뀌어 등록이 갱신된다**,
 * 그것이 의도다 (저장소가 비워졌다는 뜻이고, 옛 deviceId 로 이벤트를 보내면 안 된다).
 */
export async function registerServiceWorker(options: {
  /**
   * TV2M 주소다 — SW 가 보내는 것은 전환 이벤트(`/v1/events/bulk`)이고 그 수신자가
   * tv2m-server 다. BLOOM Server 주소와 헷갈리면 SW 만 조용히 404 를 받는다.
   *
   * **B8 이 인자로 바꿨다.** 이 값은 이제 `GET /v1/bloom/config` 로 오므로 모듈이
   * 스스로 알 수 없다.
   */
  tv2mServerUrl: string;
  tv2mApiKey: string;
  deviceId: string;
}): Promise<ServiceWorkerRegistration> {
  if (!('serviceWorker' in navigator)) {
    throw new Error('이 브라우저에는 Service Worker 가 없다 — Push 를 쓸 수 없다.');
  }

  const params = new URLSearchParams({
    server: options.tv2mServerUrl,
    key: options.tv2mApiKey,
    device: options.deviceId,
  });
  return navigator.serviceWorker.register(`/sw.js?${params.toString()}`, { scope: '/' });
}
